import { coerceGenericImagesToUrlList } from "../hotelProfileGalleryUrls";
import { buildMarketingOfferViewModel } from "./generateMarketingOffer";

function cloneJsonSafe(value) {
  if (value == null) return null;
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return null;
  }
}

/** Same gallery SSOT as hotel profile / hotel public offers — max 24 URLs. */
function normalizeSnapshotGalleryImages(...sources) {
  const raw = [];
  const push = (value) => {
    if (value == null) return;
    if (Array.isArray(value)) {
      value.forEach(push);
      return;
    }
    raw.push(value);
  };
  sources.forEach(push);
  return coerceGenericImagesToUrlList(raw).slice(0, 24);
}

/**
 * Snapshot נשמר בשרת ומוצג בעמוד ציבורי — בלי תלות ב-state נוכחי.
 * @param {object} params
 */
export function buildPublicOfferLinkSnapshot(params = {}) {
  const {
    hotelid = null,
    orderMatchesProfileHotel = false,
    currentHotelOrder = null,
    multiRoomReady = false,
    multiRoomSelections = null,
    hasRoomFromContext = false,
    ctxSelectedRoom = null,
    activePackage = null,
    selectedDepart = null,
    selectedReturn = null,
    searchPhrase = null,
    marketingOfferInput = null,
    finalPriceIls = null,
    calcTraceId = null,
    roomLineDisplay = null,
    boardLabel = null,
    customerName = null,
    branding = null,
    /** Full hotel gallery URLs (same as package profile hero gallery). */
    galleryImages = null,
    profileGalleryImages = null,
    /** Selected paid baggage (LDS supplements) — same SSOT as PDF תוספות. */
    ldsSupplement = null,
  } = params;

  const resolvedFinalIls =
    finalPriceIls != null && Number.isFinite(Number(finalPriceIls))
      ? Math.round(Number(finalPriceIls))
      : null;

  const marketingInput = marketingOfferInput || {};
  const public_view_model = buildMarketingOfferViewModel({
    ...marketingInput,
    selectedOffer: {
      ...(marketingInput.selectedOffer || {}),
      ...(resolvedFinalIls != null ? { totalPriceIls: resolvedFinalIls } : {}),
    },
  });

  const galleryUrls = normalizeSnapshotGalleryImages(
    galleryImages,
    profileGalleryImages,
    currentHotelOrder?.profileGalleryImages,
    currentHotelOrder?.galleryImages,
    marketingInput?.galleryImages,
    marketingInput?.profileGalleryImages
  );
  if (galleryUrls.length) {
    public_view_model.galleryImages = galleryUrls;
    if (!public_view_model.heroImageUrl) {
      public_view_model.heroImageUrl = galleryUrls[0];
    }
  }

  const selection = {
    mode: multiRoomReady ? "multi" : "single",
    room_line_display: roomLineDisplay || null,
    board_label: boardLabel || null,
    selected_depart: cloneJsonSafe(selectedDepart),
    selected_return: cloneJsonSafe(selectedReturn),
    search_phrase: cloneJsonSafe(searchPhrase),
  };

  if (multiRoomReady && Array.isArray(multiRoomSelections) && multiRoomSelections.length) {
    selection.multi_room_selections = cloneJsonSafe(multiRoomSelections);
  } else if (orderMatchesProfileHotel && currentHotelOrder?.selectedRoom) {
    selection.selected_room = cloneJsonSafe(currentHotelOrder.selectedRoom);
    selection.selected_package = cloneJsonSafe(currentHotelOrder.selectedHotelPackage);
  } else if (hasRoomFromContext && ctxSelectedRoom) {
    selection.selected_room = cloneJsonSafe(ctxSelectedRoom);
    selection.selected_package = cloneJsonSafe(activePackage);
  }

  const name = String(customerName || "").trim();
  const baggageSnapshot = cloneJsonSafe(ldsSupplement);

  return {
    snapshot_version: 1,
    hotel_id: hotelid != null ? String(hotelid) : null,
    final_price_ils: resolvedFinalIls,
    calc_trace_id: calcTraceId != null ? String(calcTraceId).slice(0, 128) : null,
    public_view_model,
    selection,
    ...(galleryUrls.length
      ? {
          galleryImages: galleryUrls,
          profileGalleryImages: galleryUrls,
        }
      : {}),
    ...(baggageSnapshot && typeof baggageSnapshot === "object"
      ? { ldsSupplement: baggageSnapshot }
      : {}),
    ...(name ? { customer: { name } } : {}),
    ...(branding && typeof branding === "object" ? { branding: cloneJsonSafe(branding) } : {}),
  };
}
